var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "shared/api/axios-instance";
var STATUSES = ["DRAFT", "LISTED", "PAUSED", "DELISTED"];
var toStatus = function (value) {
    return value && STATUSES.includes(value)
        ? value
        : "DRAFT";
};
var num = function (value) {
    return typeof value === "number" ? value : null;
};
var toNumber = function (value) {
    if (typeof value === "number")
        return Number.isFinite(value) ? value : null;
    if (typeof value === "string" && value.trim() !== "") {
        var parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
};
var toCounters = function (t) {
    var _a, _b, _c, _d, _e, _f;
    if (t.counters) {
        return {
            openOrders: (_a = t.counters.openOrders) !== null && _a !== void 0 ? _a : 0,
            trades: (_b = t.counters.trades) !== null && _b !== void 0 ? _b : 0,
            holders: (_c = t.counters.holders) !== null && _c !== void 0 ? _c : 0,
        };
    }
    if (t.openOrders !== undefined ||
        t.trades !== undefined ||
        t.holders !== undefined) {
        return {
            openOrders: (_d = t.openOrders) !== null && _d !== void 0 ? _d : 0,
            trades: (_e = t.trades) !== null && _e !== void 0 ? _e : 0,
            holders: (_f = t.holders) !== null && _f !== void 0 ? _f : 0,
        };
    }
    return null;
};
var toAdminToken = function (t) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return ({
        id: t.id,
        symbol: t.symbol,
        name: t.name,
        slug: (_a = t.slug) !== null && _a !== void 0 ? _a : null,
        description: (_b = t.description) !== null && _b !== void 0 ? _b : null,
        logoUrl: (_c = t.logoUrl) !== null && _c !== void 0 ? _c : null,
        network: (_d = t.network) !== null && _d !== void 0 ? _d : "BSC",
        status: toStatus(t.status),
        verified: !!t.verified,
        category: (_e = t.category) !== null && _e !== void 0 ? _e : "real-estate",
        country: (_f = t.country) !== null && _f !== void 0 ? _f : null,
        region: (_g = t.region) !== null && _g !== void 0 ? _g : null,
        latitude: num(t.latitude),
        longitude: num(t.longitude),
        address: (_h = t.address) !== null && _h !== void 0 ? _h : null,
        attributes: (_j = t.attributes) !== null && _j !== void 0 ? _j : null,
        valueUsd: toNumber(t.valueUsd),
        startingPrice: (_k = t.startingPrice) !== null && _k !== void 0 ? _k : null,
        totalSupply: toNumber(t.totalSupply),
        circulatingSupply: toNumber(t.circulatingSupply),
        currentPrice: (_l = t.currentPrice) !== null && _l !== void 0 ? _l : null,
        marketCap: (_m = t.marketCap) !== null && _m !== void 0 ? _m : null,
        quoteCoinId: (_o = t.quoteCoinId) !== null && _o !== void 0 ? _o : null,
        quoteSymbol: (_p = t.quoteSymbol) !== null && _p !== void 0 ? _p : null,
        decimals: typeof t.decimals === "number" ? t.decimals : 18,
        stats24h: t.stats24h
            ? {
                change24hPercent: num(t.stats24h.change24hPercent),
                high24h: (_q = t.stats24h.high24h) !== null && _q !== void 0 ? _q : null,
                low24h: (_r = t.stats24h.low24h) !== null && _r !== void 0 ? _r : null,
                volume24h: (_s = t.stats24h.volume24h) !== null && _s !== void 0 ? _s : null,
            }
            : null,
        counters: toCounters(t),
        onchain: t.onchain
            ? {
                contractAddress: (_t = t.onchain.contractAddress) !== null && _t !== void 0 ? _t : null,
                chainId: num(t.onchain.chainId),
                listedOnChain: !!t.onchain.listedOnChain,
                deployTxHash: (_u = t.onchain.deployTxHash) !== null && _u !== void 0 ? _u : null,
            }
            : null,
        createdAt: t.createdAt,
        updatedAt: (_v = t.updatedAt) !== null && _v !== void 0 ? _v : t.createdAt,
    });
};
var str = function (fd, key) { var _a; return (_a = fd.get(key)) !== null && _a !== void 0 ? _a : ""; };
var file = function (fd, key) {
    var value = fd.get(key);
    return value instanceof File && value.size > 0 ? value : null;
};
var appendIf = function (out, key, value) {
    if (value !== "")
        out.append(key, value);
};
var toBackendFormData = function (fd) {
    var out = new FormData();
    appendIf(out, "name", str(fd, "name"));
    appendIf(out, "symbol", str(fd, "symbol"));
    appendIf(out, "description", str(fd, "description"));
    appendIf(out, "category", str(fd, "category"));
    appendIf(out, "country", str(fd, "country"));
    appendIf(out, "region", str(fd, "region"));
    appendIf(out, "latitude", str(fd, "latitude"));
    appendIf(out, "longitude", str(fd, "longitude"));
    appendIf(out, "address", str(fd, "address"));
    appendIf(out, "attributes", str(fd, "attributes"));
    appendIf(out, "valueUsd", str(fd, "valueUsd"));
    appendIf(out, "startingPrice", str(fd, "startingPrice"));
    appendIf(out, "totalSupply", str(fd, "totalSupply"));
    appendIf(out, "quoteCoinId", str(fd, "quoteCoinId"));
    appendIf(out, "decimals", str(fd, "decimals"));
    appendIf(out, "network", str(fd, "network") || "BSC");
    out.append("verified", str(fd, "verified") === "true" ? "true" : "false");
    var image = file(fd, "image");
    if (image)
        out.append("image", image);
    return out;
};
export var tokensAdminApi = {
    getPaged: function (filters, page, limit) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens", {
                        params: {
                            search: (filters === null || filters === void 0 ? void 0 : filters.search) || undefined,
                            status: (filters === null || filters === void 0 ? void 0 : filters.status) || undefined,
                            category: (filters === null || filters === void 0 ? void 0 : filters.category) || undefined,
                            verified: (filters === null || filters === void 0 ? void 0 : filters.verified) === undefined ? undefined : filters.verified,
                            page: page,
                            limit: limit,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { data: data.data.map(toAdminToken), meta: data.meta }];
            }
        });
    }); },
    getById: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    create: function (payload) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/tokens", toBackendFormData(payload))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    update: function (id, payload) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id), toBackendFormData(payload))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    deleteOne: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/tokens/".concat(id))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    setStatus: function (id, status) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id, "/status"), { status: status })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    setVerification: function (id, verified) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id, "/verification"), { verified: verified })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    setStartingPrice: function (id, startingPrice) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id, "/starting-price"), { startingPrice: startingPrice })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    setSupply: function (id, totalSupply) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id, "/supply"), { totalSupply: totalSupply })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    setGeo: function (id, geo) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/tokens/".concat(id, "/geo"), geo)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    setImage: function (id, image) { return __awaiter(void 0, void 0, Promise, function () {
        var form, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    form = new FormData();
                    form.append("image", image);
                    return [4 /*yield*/, api.post("/admin/tokens/".concat(id, "/image"), form)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminToken(data)];
            }
        });
    }); },
    allocate: function (id, payload) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/tokens/".concat(id, "/allocate"), payload)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    listOnchain: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/tokens/".concat(id, "/list-onchain"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getOnchainStatus: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id, "/onchain-status"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getOrders: function (id, params) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id, "/orders"), {
                        params: {
                            side: params.side || undefined,
                            status: params.status || undefined,
                            userId: params.userId || undefined,
                            page: params.page,
                            limit: params.limit,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    cancelOrder: function (orderId) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/orders/".concat(orderId))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    getTrades: function (id, params) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id, "/trades"), {
                        params: {
                            from: params.from || undefined,
                            to: params.to || undefined,
                            page: params.page,
                            limit: params.limit,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getHolders: function (id, params) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id, "/holders"), { params: params })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getActivity: function (id, params) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/".concat(id, "/activity"), { params: params })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getDashboardStats: function () { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/tokens/stats")];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); },
};
